// @ts-nocheck
import { QuoteLineModel } from "@insite/client-framework/Types/ApiModels";
import {
    AvailabilityByWarehouseParameter,
    getAvailabilityByWarehouse as getAvailabilityByWarehouseApi,
} from "@store/Framework/Services/CartService";
import { TrackingInfoModel } from "@store/Framework/Types/TrackingInfoModel";
import {
    ApiHandler,
    createHandlerChainRunner,
    Handler,
    HasOnSuccess,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type Props = {
    apiParameter: AvailabilityByWarehouseParameter;
    apiResult: any;
};

type HandlerType = Handler<any, Props>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        productSkus: props.parameter.productSkus,
    };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getAvailabilityByWarehouseApi(props.apiParameter);
};

export const DispatchCompleteGetQuoteLastModifiedOn: HandlerType = props => {
    const { dispatch, apiResult } = props;
    if (apiResult.successful) {
        dispatch({
            type: "Store/Pages/CheckoutReviewAndSubmit/SetAvailabilityByWarehouse",
            availabilityByWarehouse: apiResult.result,
        });
    }
};

export const chain = [PopulateApiParameter, RequestDataFromApi, DispatchCompleteGetQuoteLastModifiedOn];

const getAvailabilityByWarehouse = createHandlerChainRunner(chain, "GetAvailabilityByWarehouse");
export default getAvailabilityByWarehouse;
